export const calendarFilterServices = {}

export type CalendarFilterServices = typeof calendarFilterServices
